import { AxiosResponse } from 'axios';
import { api } from '../base/api';
import { IReportTemplateTypeApi } from '../base/registration/reportTemplateTypeApi'; 
import { Result } from '@/main/models/common/resultResponse'; 
import { KeyValue } from '@/main/models/common';

const baseRoute: string = 'ReportTemplateType';

export class ReportTemplateTypeApi extends IReportTemplateTypeApi {
    getDomain(): Promise<AxiosResponse<Result<KeyValue[]>>> {
        return api.get(`${baseRoute}/domain`);
    }
}
